var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#348f8d",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.312 7.044a1.33 1.33 0 010 1.846l-3.13 3.209a1.29 1.29 0 01-.342.25 1.19 1.19 0 01-1.442-.211L15.28 8.944l-6.005 6.159 1.45 1.483a1.17 1.17 0 01-.007 1.62 1.105 1.105 0 01-1.582.007L6.83 15.86a1.174 1.174 0 010-1.632l.016-.015a.198.198 0 00.014-.015l7.624-7.82h.001l.001-.001.025-.026A1.147 1.147 0 0116 6.21c.072.049.14.104.2.167l2.984 3.053 2.327-2.386a1.255 1.255 0 011.802 0zm1.858 9.102a1.165 1.165 0 01.001 1.627l-.016.015a.198.198 0 00-.015.015l-7.654 7.847a1.148 1.148 0 01-1.754-.121l-2.917-2.984-2.313 2.378c-.322.332-.792.463-1.233.342s-.786-.473-.904-.925c-.117-.451.01-.933.335-1.262l3.129-3.208c.178-.186.407-.312.657-.362.404-.09.826.036 1.119.336l3.126 3.198 5.994-6.144-1.45-1.483a1.17 1.17 0 01.007-1.62 1.105 1.105 0 011.582-.007l2.273 2.325.002.002.003.002z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpp);
export default __webpack_public_path__ + "static/media/ppp.dd65f85eaf7df9c58ab2af1eb991d1df.svg";
export { ForwardRef as ReactComponent };